var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "myModal",
      staticClass: "fixedModal",
      attrs: {
        size: "lg",
        id: "modal1",
        title: "Gestión de alertas y notificaciones",
        centered: "",
        "hide-footer": true
      },
      on: { hidden: _vm.onHidden }
    },
    [
      _vm.newForm
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Titulo:",
                            "label-for": "exampleInput1"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              id: "exampleInput1",
                              name: "Titulo",
                              type: "text",
                              placeholder: "Titulo"
                            },
                            model: {
                              value: _vm.NewObject.titulo,
                              callback: function($$v) {
                                _vm.$set(_vm.NewObject, "titulo", $$v)
                              },
                              expression: "NewObject.titulo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Mensaje:",
                            "label-for": "exampleInput2"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "exampleInput2",
                              type: "text",
                              placeholder: "Mensaje"
                            },
                            model: {
                              value: _vm.NewObject.mensaje,
                              callback: function($$v) {
                                _vm.$set(_vm.NewObject, "mensaje", $$v)
                              },
                              expression: "NewObject.mensaje"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "b-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.newForm = false
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _vm._v(" "),
                      _c("b-button", { on: { click: _vm.saveAviso } }, [
                        _vm._v("Guardar")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "b-tabs",
            [
              _c("b-tab", { attrs: { title: "Alertas", active: "" } }, [
                _c(
                  "div",
                  { staticClass: "scroll" },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("v-server-table", {
                      ref: "table1",
                      attrs: {
                        url: "avisos/",
                        options: _vm.alOpt,
                        columns: _vm.alCol
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "titulo",
                          fn: function(props) {
                            return _c("span", {
                              domProps: { innerHTML: _vm._s(props.row.titulo) }
                            })
                          }
                        },
                        {
                          key: "mensaje",
                          fn: function(props) {
                            return _c("span", {
                              domProps: { innerHTML: _vm._s(props.row.mensaje) }
                            })
                          }
                        },
                        {
                          key: "Acciones",
                          fn: function(props) {
                            return _c(
                              "span",
                              {},
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.deleteRow(props.row)
                                      }
                                    }
                                  },
                                  [_vm._v("Eliminar")]
                                )
                              ],
                              1
                            )
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "b-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.newAviso("alerta")
                                  }
                                }
                              },
                              [_vm._v("Nueva alerta")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-tab", { attrs: { title: "Notificaciones" } }, [
                _c(
                  "div",
                  { staticClass: "scroll" },
                  [
                    _c("br"),
                    _vm._v(" "),
                    _c("v-server-table", {
                      ref: "table2",
                      attrs: {
                        url: "avisos/",
                        options: _vm.notOpt,
                        columns: _vm.notCol
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "titulo",
                          fn: function(props) {
                            return _c("span", {
                              domProps: { innerHTML: _vm._s(props.row.titulo) }
                            })
                          }
                        },
                        {
                          key: "mensaje",
                          fn: function(props) {
                            return _c("span", {
                              domProps: { innerHTML: _vm._s(props.row.mensaje) }
                            })
                          }
                        },
                        {
                          key: "Acciones",
                          fn: function(props) {
                            return _c(
                              "span",
                              {},
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.deleteRow(props.row)
                                      }
                                    }
                                  },
                                  [_vm._v("Eliminar")]
                                )
                              ],
                              1
                            )
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "b-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.newAviso("notificacion")
                                  }
                                }
                              },
                              [_vm._v("Nueva notificación")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/ManageAlerts.vue?vue&type=template&id=baf7ce7e&
// module id = null
// module chunks = 